//
export default class AccAccountingSeatConceptFilters {

  /**
   * 
   */
  static toList() {
    return [
      {
        name: 'code',
        type: 'text-field',
        props: {
          label: 'Codigo',
        },
      },
      {
        name: 'concept',
        type: 'text-field',
        props: {
          label: 'Concepto',
        },
      },
      {
        name: 'concept',
        type: 'select',
        props: {
          clearable: true,
          label: 'Removible',
          items: [
            {
              text: 'Si',
              value: '1',
            },
            {
              text: 'No',
              value: '0',
            },
          ],
        },
      },
    ]
  } 
}